import React from 'react';
import { Link } from 'gatsby';

import { ThemeProvider } from 'styled-components';

import ButtonTertiary from '../ButtonTertiary';
import { Module, Top, Bottom, Card } from './styles';
import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import OImage from '../OImage';
import { ButtonSmall } from '../../ui/Button';
import { externalLink } from '../../ui/helpers';

interface INews {
  key?: string;
  title: string;
  description: string;
  date: string;
  link: { uri?: string; title?: string };
  imageUrl: any;
  imageAlt?: string;
}

interface IProps {
  theme?: string;
  gradient?: Boolean;
  translations: any;
  headingEl?: keyof JSX.IntrinsicElements;
  news: INews[];
  allNews?: any;
  gtmAction?: string;
}

const CenterNews = ({ gradient = false, translations, headingEl, news, allNews, gtmAction }: IProps) => {
  const Heading = headingEl || 'div';
  const cleanedTheme = gradient ? 'generic_gradient' : 'white';
  return (
    <ThemeProvider theme={themes[gradient ? 'gradients' : 'basic'][cleanedTheme]}>
      <Module gradient={gradient}>
        <Wrapper as={Top} size="reader">
          {translations?.centerPage?.lastNews && <Heading className="title">{translations.centerPage.news}</Heading>}
        </Wrapper>
        <Wrapper as={Bottom} size="mainwrapper">
          {news.map((item, i) => {
            let splittedUrl, imageName, query, baseUrl, finalUrl;

            const customEncodeURIComponent = (str) => {
              return encodeURIComponent(str)
                .replace(/\(/g, '%28')
                .replace(/\)/g, '%29')
                .replace(/'/g, '%27')
                .replace(/!/g, '%21')
                .replace(/\*/g, '%2A');
            };

            const getImageUrl = (links, size) => {
              if (links && links[size] && links[size].href) {
                return links[size].href;
              }
              return null;
            };

            const href = getImageUrl(item.imageUrl, 'xsmall_webp')
              || getImageUrl(item.imageUrl, 'xsmall');

            if (href) {
              splittedUrl = href.split('/');
              imageName = splittedUrl[splittedUrl.length - 1];
              query = imageName.split('?')[1];
              baseUrl = href.replace(imageName, '');
              imageName = imageName.replace('?' + query, '');
              finalUrl = baseUrl + customEncodeURIComponent(imageName) + '?' + query;
            }

            return (
              <Card key={item?.key + '_' + i}>
                <div className="imageZone">
                  <OImage
                    aspectRatio={3 / 2}
                    alt={item?.imageAlt || ''}
                    className="image"
                    bg={
                      finalUrl
                    }
                  />
                </div>
                <div className="contentZone">
                  <p className="ctitle">
                    <a
                      href={item.link.uri}
                      data-gtm-event
                      data-gtm-category="cta"
                      data-gtm-action={gtmAction}
                      data-gtm-label={`${item.title}_${item.link.uri}`}>
                      {item.title}
                    </a>
                  </p>
                  <p className="description">{item.description}</p>
                  <div className="extra">{item.date && <div className="date">{item.date}</div>}</div>
                  {item.link?.uri && (
                    <ButtonTertiary
                      to={item.link?.uri}
                      target={`${externalLink(item.link?.uri) ? '_blank' : undefined}`}
                      label={translations?.news?.findOutMore || 'Saber más'}
                      className="btn"
                      data-gtm-event
                      data-gtm-label={`${item.link?.title}_${typeof window !== 'undefined' ? window.location.href : ''
                        }`}
                    />
                  )}
                </div>
              </Card>
            )
          })}
        </Wrapper>
        {allNews && (
          <div className="ctaContainer">
            <ButtonSmall
              as={externalLink(allNews.uri) ? 'a' : Link}
              className="btn"
              href={externalLink(allNews.uri) ? allNews.uri : null}
              to={externalLink(allNews.title) ? null : allNews.uri}
              target={externalLink(allNews.uri) ? '_blank' : null}
              rel={externalLink(allNews.uri) ? 'nofollow noopener noreferrer' : null}
              secondary={1}>
              {allNews.title}
            </ButtonSmall>
          </div>
        )}
      </Module>
    </ThemeProvider>
  );
};
export default CenterNews;
